export default __webpack_public_path__ + "assets/images/de04fc38fbf3a2e32c491f8a53aef9ed.png";